import React, { useState } from 'react'
import InputCustom from '../../../../components/elements/InputCustom'
import TextAreaCustom from '../../../../components/elements/TextAreaCustom'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'

function ProductFiles({title,fields , setFields}) {
    //const [fields, setFields] = useState([{ file_path: '', notes: '' }])
    const { translate } = AbstructLang()
    const handleFieldChange = (index, field, value) => {
        const newFields = [...fields]
        newFields[index][field] = value
        setFields(newFields)
    }

    const addField = () => {
        const newFields = [...fields, { file_path: '', notes: '' }]
        setFields(newFields)
    }

    const removeField = (index) => {
        const newFields = [...fields]
        newFields.splice(index, 1)
        setFields(newFields)
    }

    return (
        <>
            <p className='basic-pro' style={{marginBottom: "7px"}} >{title}</p>
            {fields.map((field, index) => (
                <div key={index} className='d-flex' >
                    <div style={{ width: "275px" }} >
                        <InputCustom
                            label='file'
                            iconType='file'
                            type='file'
                            value={field.file_path}
                            onChange={handleFieldChange/*(index, 'file_path', e.target.value)*/}
                            index={index}
                        />
                    </div>
                    <div className='one-text-area w-70' >
                        <TextAreaCustom
                            label='notes'
                            value={field.notes}
                            onChange={(e) => handleFieldChange(index, 'notes', e.target.value)}
                            nameClass='textarea-gen'
                            withFiles
                        />
                    </div>
                    {
                        index === 0 && (
                            <i className='fa fa-plus plus-arr' onClick={addField} ></i>
                        )
                    }
                    {
                        index > 0 && (
                            <i className='fa fa-minus minus-arr' onClick={() => removeField(index)} ></i>
                        )
                    }
                </div>
            ))}
        </>
    )
}

export default ProductFiles